"use strict";
// IDE'de proje adı, form adı vb. alanlarda bazı isimlendirmeler kullanılamamaktadır.
// Bu fonksiyonla birlikte ilgili ismin kullanılıp kullanılamadığı bilgisi kullanıcıya döndürülmektedir.
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@bimser/core");
exports.default = (name) => Boolean(core_1.FormItemTypes.EControlTypes[name] || core_1.FlowItemTypes[name]);
//# sourceMappingURL=isNameForbidden.js.map